import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
import { MAX_MANUFACTURING_ORDER_LINES } from './constraints.js';
import { MAX_WORK_ORDERS_PER_LINE } from './split-quantities.js';
import { ticketPlanSchema } from './ticket-plan.js';
export const MAX_LINE_SPLITS_MESSAGE = `A release can carry at most ${MAX_MANUFACTURING_ORDER_LINES} line splits.`;
export const LINE_SPLIT_ONCE_MESSAGE = 'Each part line can be split only once.';
export const LINE_SPLIT_EMPTY_MESSAGE = 'A split must name at least one work order.';
export const MAX_WORK_ORDERS_PER_LINE_MESSAGE = `A line can be split across at most ${MAX_WORK_ORDERS_PER_LINE} work orders.`;
/**
 * How the planner cut each line into tickets — a line left alone sends no entry at all, so an
 * absent line and a never-split line take the one code path `expandSplitQuantities` already has.
 */
export const lineSplitsSchema = z
    .array(z.object({
    manufacturingOrderItemId: requiredUuidString('Each split must name a part line.', 'Invalid part line on a split.'),
    tickets: z
        .array(ticketPlanSchema)
        .min(1, LINE_SPLIT_EMPTY_MESSAGE)
        .max(MAX_WORK_ORDERS_PER_LINE, MAX_WORK_ORDERS_PER_LINE_MESSAGE),
}))
    .max(MAX_MANUFACTURING_ORDER_LINES, MAX_LINE_SPLITS_MESSAGE)
    // Two splits for one line would write whichever landed second, silently discarding the other.
    .refine((splits) => {
    const seen = new Set();
    for (const split of splits) {
        if (seen.has(split.manufacturingOrderItemId))
            return false;
        seen.add(split.manufacturingOrderItemId);
    }
    return true;
}, LINE_SPLIT_ONCE_MESSAGE);
//# sourceMappingURL=line-splits.js.map